import { useTranslate } from '@ur-solutions/react-hooks'
import { useNavigate } from 'react-router'
import { useToast } from '@ur-solutions/react-components'
import { useMutation } from '@apollo/client'
import { EXPORT_USERS } from './mutations'
import type {
  UserExportMutations,
  UserExportMutationsInput,
} from './types.graphql'

export function useUserExportMutations(onCompleted?: () => void) {
  const translations = useTranslate({
    error: 'error.generic-server-error',
    downloadSuccess: 'exports.success-user-exports',
    exportTimeout: 'exports.export-timeout',
  })

  const navigate = useNavigate()

  const addToast = useToast()

  const [exportUsers, { loading }] = useMutation<
    UserExportMutations,
    UserExportMutationsInput
  >(EXPORT_USERS, {
    onCompleted(data) {
      if (data?.exportUsers?.exportTimeout) {
        addToast('info', translations.exportTimeout)
      } else if (data?.exportUsers?.html) {
        void navigate('/export', {
          state: { html: data?.exportUsers?.html },
        })
      } else if (data?.exportUsers?.ok) {
        addToast('success', translations.downloadSuccess)
      } else {
        addToast('error', translations.error)
      }
      onCompleted?.()
    },
  })

  return {
    exportUsers,
    loading,
  }
}
